const keyStatistics = {
  999: {
    sharpeRatio: 1.66,
    zValue: 0.98,
    ahpr: 1.04,
    ghpr: 1.03,
  }
}

export default keyStatistics;